<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <div class="template-sharing-button">
            <el-switch
              style="display: block"
              v-model="field.countryCodeSelector"
              active-color="#13ce66"
              inactive-color="#ff4949"
              inactive-text="Custom"
              active-text="Standard"
              v-on:change="onUpdate"
            ></el-switch>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="vue-phone-validator">
            <VuePhoneNumberInput
              class="vue-phone-validator"
              required
              :default-country-code="field.defaultCountry"
              v-model="field.phoneNo"
              @update="onUpdate"
            />
          </div>
          
          <el-tooltip
            placement="top-start"
            trigger="hover"
            effect="dark"
            popper-class="custom-tooltip"
            :content="`Your first selected country code will be 
            set as the default for the phone number field. 
            The customized country codes will be 
            displayed first in the country code dropdown.`"
          >
            <label class="mt-2">Customize Country Codes <i class="el-icon-info"></i></label>
          </el-tooltip>
          <el-select
            v-model="field.validations.preferredCountries"
            filterable
            multiple
            placeholder="Select Country"
          >
            <el-option
              v-for="country in countryOptions"
              :key="country.code"
              :label="`${country.dialCode} - ${country.name}`"
              :value="country.code"
            />
          </el-select>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="12" class="mt">
          <field-filled-by :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" />
        </el-col>
        <el-col :span="10">
          <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>

      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <field-attributes :field="field" />
        </el-col>
      </el-row>
      <div class="mt-1"></div>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    TitleAndDescription: () => import("./TitleAndDescription"),
    IsFieldRequired: () => import("./IsFieldRequired"),
    FieldFilledBy: () => import("./FieldFilledBy"),
    VuePhoneNumberInput: () => import("vue-phone-number-input"),
    FieldAttributes: () => import("./FieldAttributes"),
  },
  props: ["field"],
  data() {
    return {
      preferredCountries: [],
      validations: [],
      countryOptions: [
        { name: "Afghanistan", code: "AF", dialCode: "+93" },
        { name: "Albania", code: "AL", dialCode: "+355" },
        { name: "Algeria", code: "DZ", dialCode: "+213" },
        { name: "Andorra", code: "AD", dialCode: "+376" },
        { name: "Angola", code: "AO", dialCode: "+244" },
        { name: "Argentina", code: "AR", dialCode: "+54" },
        { name: "Armenia", code: "AM", dialCode: "+374" },
        { name: "Australia", code: "AU", dialCode: "+61" },
        { name: "Austria", code: "AT", dialCode: "+43" },
        { name: "Azerbaijan", code: "AZ", dialCode: "+994" },
        { name: "Bahrain", code: "BH", dialCode: "+973" },
        { name: "Bangladesh", code: "BD", dialCode: "+880" },
        { name: "Belarus", code: "BY", dialCode: "+375" },
        { name: "Belgium", code: "BE", dialCode: "+32" },
        { name: "Bhutan", code: "BT", dialCode: "+975" },
        { name: "Brazil", code: "BR", dialCode: "+55" },
        { name: "Canada", code: "CA", dialCode: "+1" },
        { name: "China", code: "CN", dialCode: "+86" },
        { name: "Denmark", code: "DK", dialCode: "+45" },
        { name: "Egypt", code: "EG", dialCode: "+20" },
        { name: "France", code: "FR", dialCode: "+33" },
        { name: "Germany", code: "DE", dialCode: "+49" },
        { name: "India", code: "IN", dialCode: "+91" },
        { name: "Indonesia", code: "ID", dialCode: "+62" },
        { name: "Iran", code: "IR", dialCode: "+98" },
        { name: "Iraq", code: "IQ", dialCode: "+964" },
        { name: "Italy", code: "IT", dialCode: "+39" },
        { name: "Japan", code: "JP", dialCode: "+81" },
        { name: "Kenya", code: "KE", dialCode: "+254" },
        { name: "Malaysia", code: "MY", dialCode: "+60" },
        { name: "Mexico", code: "MX", dialCode: "+52" },
        { name: "Nepal", code: "NP", dialCode: "+977" },
        { name: "Netherlands", code: "NL", dialCode: "+31" },
        { name: "New Zealand", code: "NZ", dialCode: "+64" },
        { name: "Nigeria", code: "NG", dialCode: "+234" },
        { name: "Pakistan", code: "PK", dialCode: "+92" },
        { name: "Philippines", code: "PH", dialCode: "+63" },
        { name: "Russia", code: "RU", dialCode: "+7" },
        { name: "Saudi Arabia", code: "SA", dialCode: "+966" },
        { name: "South Africa", code: "ZA", dialCode: "+27" },
        { name: "South Korea", code: "KR", dialCode: "+82" },
        { name: "Spain", code: "ES", dialCode: "+34" },
        { name: "Sri Lanka", code: "LK", dialCode: "+94" },
        { name: "Sweden", code: "SE", dialCode: "+46" },
        { name: "Switzerland", code: "CH", dialCode: "+41" },
        { name: "Thailand", code: "TH", dialCode: "+66" },
        { name: "Turkey", code: "TR", dialCode: "+90" },
        { name: "United Arab Emirates", code: "AE", dialCode: "+971" },
        { name: "United Kingdom", code: "GB", dialCode: "+44" },
        { name: "United States", code: "US", dialCode: "+1" },
        { name: "Vietnam", code: "VN", dialCode: "+84" },
        { name: "Zimbabwe", code: "ZW", dialCode: "+263" },
      ],
      iconPickerdialogVisible: false,
      templateIconPath:'',
    };
  },
  mounted(){
    if (this.field && this.field.icon_name) {
      this.templateIconPath = this.field.icon_name;
    }
  },
  computed:{
    ...mapGetters("navigationOpen", ["getIsMobile", "getIsRSOpen"]),
  },
  methods: {
    closeSelectIcon() {
      this.iconPickerdialogVisible = false;
    },
    getIconPath(icon) {
      this.templateIconPath = icon;
      this.$set(this.field, "icon_name", icon);
      this.iconPickerdialogVisible = false;
    },
    onUpdate(payload) {
      if (this.field.countryCodeSelector == true) {
        this.standardCode = false;
        this.field.countryDisable = false;
        this.field.countryCallingCode = payload.countryCallingCode;
        this.field.defaultCountry = payload.countryCode;
      } else {
        this.field.defaultCountry = payload.countryCode;
        this.field.countryCallingCode = payload.countryCallingCode;
        this.field.countryDisable = true;
      }
    },
    openSettings() {
      this.$emit("settings");
    },
  },
};
</script>

<style lang="scss">
.mt {
  margin-top: 10px;
}
.custom-tooltip {
  max-width: 250px; 
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.5;
}
</style>
